<ng-container *ngIf="expirations">
    <app-if-table
    [ifTable]="expirationsIFTable"
    [ifDocument]="expirations"
    ></app-if-table>
  </ng-container>
